import React from 'react';
import styled from 'styled-components';

import { CtaButton, SectionHeadline } from '../styled';

const Container = styled.div`
  background: #08111e;
  padding-top: 44px;
`;

const Inner = styled.div`
  text-align: center;
`;

const Headline = styled(SectionHeadline)`
  color: #ffffff;
  max-width: 480px;
  margin: 0 auto;
  margin-bottom: 16px;
`;

const Subheadline = styled.div`
  color: #666666;
  max-width: 360px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
  letter-spacing: 0.54px;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  padding-bottom: 80px;
`;

function CurrencyFamilyInfo({ input }) {
  return (
    <Container>
      <Inner>
        <Headline>{input.primary.headline.text}</Headline>
        <Subheadline>{input.primary.subheadline.text}</Subheadline>
        <ButtonContainer>
          <a href={input.primary.cta_link.url}>
            <CtaButton type="button">{input.primary.cta_label.text}</CtaButton>
          </a>
        </ButtonContainer>
      </Inner>
    </Container>
  );
}

export { CurrencyFamilyInfo };
